import React, { Component } from 'react';
import { ErrorMessage, Field } from 'formik';
import { FieldTypes } from 'drapcode-constant';

class MapFieldForm extends Component {
  requiredValidate = (value) => {
    const { required } = this.props.field;
    let error;
    if (required && !value) {
      error = 'This field is required';
    }
    // } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    //     error = 'Invalid email address';
    // }
    console.log(error);
    return error;
  };
  getCsvHeaderOption = () => {
    const { csvHeader } = this.props.import;
    if (csvHeader) {
      return csvHeader.map((column, i) => {
        return (
          <option key={i} value={column}>
            {column}
          </option>
        );
      });
    }
  };

  renderFormControl = () => {
    const { field } = this.props;
    switch (field.type) {
      case FieldTypes.file.id:
      case FieldTypes.image.id:
      case FieldTypes.reference.id:
      case FieldTypes.multi_image.id:
      case FieldTypes.updatedAt.id:
      case FieldTypes.createdAt.id:
      case FieldTypes.createdBy.id:
        return (
          <div className="form-group">
            <label htmlFor={field.fieldName} className="col-form-label">
              {field.fieldTitle['en']}
              {field.required ? ' *' : ''}{' '}
            </label>
            <Field as="select" name={field.fieldName} disabled className="form-control">
              <option key={''}>DO NOT IMPORT</option>
              {/*{this.getCsvHeaderOption()}*/}
            </Field>
            <p className="errors">
              {/*<ErrorMessage name={field.fieldName}/>*/}
              csv data cannot be mapped to item {field.type} fields
            </p>
          </div>
        );
      default:
        return (
          <div className="form-group">
            <label htmlFor={field.fieldName} className="col-form-label">
              {field.fieldTitle['en']}
              {field.required ? ' *' : ''}{' '}
            </label>
            <Field
              as="select"
              name={field.fieldName}
              validate={this.requiredValidate}
              className="form-control"
            >
              <option key={''}>DO NOT IMPORT</option>
              {this.getCsvHeaderOption()}
            </Field>
            <p className="errors">
              <ErrorMessage name={field.fieldName} />
            </p>
          </div>
        );
    }
  };

  render() {
    return <React.Fragment>{this.renderFormControl()}</React.Fragment>;
  }
}

// if (object.type === FieldTypes.text.id) {
//     return (<div className="form-group" key={i}>
//             <label>{object.fieldTitle['en']}</label>
//             <Field type="text" name={object.fieldName} palaceholder={object.placeholder['en']}
//                    className="form-control"/>
//         </div>
//     )
// }
// if (object.type === FieldTypes.large_text.id) {
//     return (<div className="form-group" key={i}>
//             <label>{object.fieldTitle['en']}</label>
//             <Field type="text" as="textarea"
//                    className="form-control" name={object.fieldName}
//                    palaceholder={object.placeholder['en']}
//                    required={object.required} height="100px" width="200px"/>
//         </div>
//     )
// }
//
// if (object.type === FieldTypes.number.id) {
//     return (<div className="form-group" key={i}>
//             <label>{object.fieldTitle['en']}</label>
//             <Field type="number" className="form-control" name={object.fieldName}
//                    palaceholder={object.placeholder['en']}
//                    required={object.required}
//                    min={object.validation.min} max={object.validation.max}/>
//         </div>
//     )
// }
//
// if (object.type === FieldTypes.date.id) {
//     return (<div className="form-group" key={i}>
//             <label>{object.fieldTitle['en']}</label>
//             <Field type="text" className="form-control" name={object.fieldName}
//                    required={object.required}/>
//         </div>
//     )
// }
// if (object.type === FieldTypes.password.id) {
//     return (<div className="form-group" key={i}>
//             <label>{object.fieldTitle['en']}</label>
//             <Field type="password"
//                    name={object.fieldName}
//                    palaceholder={object.placeholder['en']}
//                    className="form-control"
//             />
//         </div>
//     )
// }

export default MapFieldForm;
